module.exports = __webpack_public_path__ + "img/cabinet_211.a59fa0c2.jpg";